import { XIcon } from '@langchain/untitled-ui-icons';

import { useEffect, useState } from 'react';

import { BlobStorageWarningBanner } from '@/components/BlobStorageWarningBanner';
import { IconButton } from '@/design-system';
import { InstanceFlags, useInstanceFlag } from '@/hooks/useInstanceFlag';
import { useInstanceHealth } from '@/hooks/useSwr';

export function InstanceHealthBanner() {
  const [visible, setVisible] = useState(false);
  const { data } = useInstanceHealth();
  const blobStorageEnabled = useInstanceFlag(
    InstanceFlags.blob_storage_enabled
  );

  useEffect(() => {
    if (data?.clickhouse_disk_free_pct && data?.clickhouse_disk_free_pct < 10) {
      setVisible(true);
    }
  }, [data?.clickhouse_disk_free_pct]);

  return visible ? (
    <div className="flex items-center justify-center gap-2 bg-warning-secondary px-4 py-2 text-center text-sm text-ls-black">
      <div className="flex grow items-center justify-center gap-2">
        ClickHouse disk has less than 10% remaining. Please contact your
        clickhouse or storage administrator to resolve.
      </div>
      <IconButton
        size="sm"
        variant="plain"
        icon={XIcon}
        label="Close"
        onClick={() => setVisible(false)}
      />
    </div>
  ) : !blobStorageEnabled ? (
    <BlobStorageWarningBanner />
  ) : null;
}
